import { dataViewI18nT } from '../i18n.js';

interface ViewNameMeta {
  type: string;
  model: { defaultName: string };
}

/** The default name of a view type in the reader's language. */
export const localizedViewDefaultName = ({
  type,
  model,
}: ViewNameMeta): string =>
  type === 'table' ? dataViewI18nT('table.defaultName') : model.defaultName;

/**
 * The name a view shows. The app and the server store a new view under its
 * type's default name; such a view shows that name in the reader's language,
 * a renamed view shows its own name.
 */
export const viewDisplayName = (meta: ViewNameMeta, name: string): string =>
  name === meta.model.defaultName ? localizedViewDefaultName(meta) : name;
